// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    width={431}
    height={336}
    viewBox="0 0 431 336"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M120.209 244.825L119.901 244.578C118.517 243.471 116.751 242.958 114.991 243.151C113.23 243.345 111.619 244.229 110.512 245.609L110.31 245.861L109.652 245.415L109.889 245.12C111.001 243.748 111.526 241.992 111.35 240.234C111.264 239.368 111.005 238.527 110.588 237.763C110.171 236.998 109.605 236.325 108.922 235.783V235.783L109.359 235.237L109.36 235.238C111.925 237.291 115.777 237.786 118.575 234.29L118.815 233.991L119.38 234.537L119.223 234.778C117.28 237.771 117.801 241.889 120.384 243.958L120.627 244.152L120.209 244.825ZM111.526 243.716C112.545 243.016 113.722 242.581 114.952 242.453C116.182 242.324 117.425 242.506 118.568 242.98C117.923 241.953 117.521 240.792 117.393 239.586C117.265 238.381 117.415 237.162 117.831 236.023C116.883 236.802 115.74 237.304 114.525 237.475C113.311 237.646 112.072 237.479 110.945 236.993C111.557 237.949 111.934 239.036 112.046 240.164C112.169 241.373 111.991 242.594 111.526 243.716V243.716Z"
      fill="#29292F"
    />
    <path
      d="M63.2899 181.464L62.7773 181.967L99.6162 219.532L100.129 219.03L63.2899 181.464Z"
      fill="#29292F"
    />
    <path
      d="M75.9408 208.85L75.4666 209.389L98.9744 230.075L99.4487 229.536L75.9408 208.85Z"
      fill="#29292F"
    />
    <path
      d="M117.728 148.672C127.143 198.89 166.801 250.247 259.938 250.437"
      stroke="#FF9DBE"
      strokeWidth={33}
    />
    <path
      d="M128.074 148.822C131.417 147.557 133.441 146.231 133.224 145.24C133.017 144.278 130.739 143.829 127.322 143.901C124.536 143.961 120.987 144.365 117.178 145.12C113.719 145.805 110.578 146.674 108.098 147.58C104.498 148.895 102.29 150.289 102.515 151.323C102.719 152.267 104.903 152.715 108.2 152.667C111.02 152.625 114.653 152.219 118.562 151.444C122.225 150.719 125.528 149.784 128.074 148.822Z"
      fill="#FF73A9"
    />
    <path
      d="M119.85 151.395C119.437 151.484 119.021 151.57 118.603 151.653C114.83 152.4 111.136 152.835 108.201 152.879C105.671 152.916 102.593 152.685 102.306 151.369C101.975 149.834 105.742 148.213 108.022 147.381C110.62 146.432 113.766 145.574 117.134 144.912C120.797 144.185 124.413 143.752 127.313 143.689C129.94 143.635 133.134 143.851 133.428 145.196C133.745 146.665 130.256 148.223 128.146 149.021C125.825 149.902 122.916 150.733 119.85 151.395ZM115.948 145.59C113.087 146.208 110.419 146.959 108.17 147.779C103.92 149.332 102.58 150.634 102.72 151.279C102.851 151.884 104.359 152.51 108.196 152.454C111.104 152.411 114.771 151.98 118.52 151.236C122.019 150.541 125.384 149.614 127.999 148.622C131.915 147.141 133.16 145.927 133.019 145.285C132.885 144.663 131.317 144.029 127.326 144.115C124.449 144.175 120.86 144.607 117.219 145.327C116.792 145.413 116.37 145.499 115.948 145.59Z"
      fill="#29292F"
    />
    <path
      d="M125.893 98.8641C122.377 100.515 119.608 103.441 118.134 107.062C117.972 107.456 117.831 107.858 117.7 108.263C116.332 96.6474 121.502 91.1027 121.775 90.8186C121.73 90.8662 121.704 90.8888 121.704 90.8888L121.682 90.8652C122.67 89.8477 123.26 88.5041 123.345 87.0798C123.43 85.6555 123.005 84.2456 122.147 83.1077C121.197 81.8509 119.794 81.0239 118.245 80.8087C116.696 80.5935 115.129 81.0077 113.887 81.9601C113.763 82.0551 113.649 82.158 113.533 82.2615L113.517 82.2442C113.002 82.7401 102.17 93.521 106.796 114.559C102.215 102.894 97.6226 94.7021 97.3565 94.2368C96.5786 92.8595 95.2919 91.8481 93.7793 91.425C92.2668 91.002 90.6523 91.202 89.2909 91.9809C87.9295 92.7602 86.9329 94.0548 86.5203 95.5798C86.1076 97.1049 86.3126 98.7356 87.0904 100.113C87.1661 100.247 94.1534 113.992 99.0343 127.904C104.233 142.724 106.798 153.469 106.566 152.653C114.518 152.95 125.768 150.184 130.602 147.739C130.602 147.739 127.435 136.916 135.127 134.786C136.394 134.535 137.339 134.387 138.702 133.97C140.683 133.479 142.543 132.585 144.167 131.344C147.919 128.469 150.18 123.874 149.982 118.779C149.92 117.197 149.238 115.703 148.086 114.624C146.935 113.545 145.407 112.97 143.841 113.026C143.065 113.053 142.303 113.235 141.598 113.56C140.893 113.885 140.259 114.348 139.732 114.921C139.205 115.494 138.796 116.167 138.528 116.901C138.259 117.635 138.137 118.416 138.167 119.199C138.247 121.234 136.811 122.219 135.557 122.444C132.993 122.903 130.545 120.595 129.165 116.429C127.675 111.646 130.122 110.069 130.909 109.701C131.481 109.433 133.453 108.728 134.816 110.894C135.234 111.557 135.776 112.13 136.413 112.582C137.049 113.033 137.767 113.355 138.526 113.527C139.284 113.699 140.068 113.718 140.832 113.585C141.597 113.451 142.327 113.166 142.982 112.747C143.124 112.653 143.262 112.557 143.394 112.458C144.569 111.554 145.365 110.237 145.622 108.766C145.879 107.295 145.58 105.777 144.783 104.514C140.695 98.0229 132.75 95.6503 125.893 98.8641Z"
      fill="#FFD5E1"
    />
    <path
      d="M143.837 112.805C143.618 112.813 143.4 112.833 143.184 112.864C143.301 112.785 143.416 112.704 143.526 112.618C146.032 110.698 146.664 107.085 144.965 104.391C141.457 98.8302 135.152 96.2529 129.082 97.563C127.953 97.8077 126.855 98.1791 125.809 98.6704C122.246 100.343 119.44 103.306 117.945 106.975C117.902 107.079 117.859 107.188 117.816 107.298C116.833 96.3936 121.714 91.1891 121.931 90.9625L121.906 90.9367C122.893 89.876 123.475 88.496 123.55 87.0403C123.626 85.5846 123.189 84.1466 122.318 82.9798C121.833 82.333 121.227 81.7891 120.533 81.3798C119.84 80.9705 119.073 80.7038 118.278 80.5953C117.484 80.482 116.675 80.5289 115.9 80.7334C115.125 80.9378 114.399 81.2957 113.763 81.7863C113.689 81.844 113.617 81.9029 113.548 81.9632L113.525 81.9407L113.37 82.0868C112.917 82.5228 102.698 92.646 106.148 112.376C101.835 101.774 97.7231 94.4534 97.5396 94.1281C96.7325 92.7032 95.3998 91.6571 93.8339 91.2193C92.268 90.7815 90.5967 90.9876 89.1864 91.7926C88.4871 92.1903 87.8735 92.7244 87.3812 93.3641C86.8889 94.0037 86.5276 94.7361 86.3183 95.5189C86.104 96.3005 86.0458 97.1178 86.147 97.9236C86.2482 98.7294 86.5067 99.5075 86.9077 100.213C86.9687 100.326 93.9643 114.083 98.8361 127.971C103.292 140.674 105.871 150.591 106.307 152.423L106.283 152.422L106.413 152.867L106.655 152.924L106.709 152.862C110.56 152.985 115.325 152.381 119.753 151.426C124.133 150.48 128.189 149.188 130.696 147.92L130.853 147.842L130.803 147.672C130.786 147.614 129.135 141.836 131.237 138.016C132.073 136.497 133.402 135.475 135.168 134.986L135.818 134.86C136.81 134.688 137.791 134.457 138.756 134.168C140.765 133.671 142.651 132.765 144.297 131.505C148.185 128.524 150.392 123.761 150.193 118.763C150.127 117.127 149.421 115.581 148.229 114.464C147.038 113.347 145.458 112.751 143.837 112.805V112.805ZM113.518 82.5417L113.525 82.5505L113.676 82.4159C113.787 82.3171 113.899 82.2175 114.018 82.1246C115.216 81.2081 116.728 80.8105 118.221 81.0189C119.715 81.2273 121.068 82.0248 121.983 83.2364C122.804 84.3353 123.21 85.6923 123.129 87.0628C123.047 88.4334 122.483 89.7274 121.539 90.7117L121.418 90.8823L121.428 90.8925C120.428 92.0708 116.26 97.68 117.493 108.246C117.363 108.746 116.287 113.285 117.979 117.594C114.344 118.432 111.423 119.584 109.166 120.721C107.485 116.755 106.835 113.692 106.707 113.04C106.702 113.015 106.696 112.99 106.691 112.965C106.686 112.941 106.683 112.93 106.68 112.913C103.134 94.0464 112.173 83.9209 113.513 82.5427L113.518 82.5417ZM149.775 118.778C149.966 123.639 147.823 128.27 144.045 131.17C142.44 132.398 140.603 133.28 138.645 133.763C137.692 134.047 136.724 134.275 135.744 134.446L135.076 134.576C133.18 135.102 131.766 136.19 130.873 137.813C128.869 141.46 130.086 146.601 130.358 147.622C125.284 150.126 114.235 152.686 106.708 152.443C106.305 150.246 103.244 139.252 99.239 127.835C94.3869 114.004 87.3369 100.112 87.2795 100.011C86.9059 99.3536 86.665 98.6288 86.5706 97.8782C86.4762 97.1276 86.5302 96.3662 86.7296 95.6382C86.9245 94.9091 87.2611 94.2269 87.7197 93.6312C88.1783 93.0355 88.7498 92.5381 89.4012 92.1678C90.0508 91.7941 90.7678 91.5543 91.5109 91.4622C92.2539 91.3701 93.0084 91.4276 93.7306 91.6312C94.4536 91.8313 95.1307 92.174 95.7228 92.6395C96.3149 93.1049 96.8101 93.6839 97.1799 94.3428C97.3752 94.6883 102.086 103.093 106.68 114.791C107.235 116.882 107.94 118.931 108.789 120.92C104.993 122.895 103.204 124.768 103.171 124.802L103.478 125.093C103.537 125.03 109.567 118.741 123.151 117.139L123.101 116.717C121.418 116.916 119.85 117.186 118.393 117.508C116.672 113.202 117.826 108.627 117.902 108.337L117.906 108.323C118.047 107.884 118.187 107.499 118.332 107.144C119.058 105.372 120.102 103.752 121.413 102.365C122.719 100.985 124.271 99.8648 125.987 99.0611C132.749 95.8877 140.58 98.2338 144.612 104.623C145.374 105.843 145.658 107.305 145.411 108.722C145.163 110.139 144.4 111.409 143.272 112.286C143.144 112.383 143.012 112.476 142.875 112.565C141.6 113.378 140.055 113.647 138.58 113.311C137.105 112.976 135.818 112.065 135.004 110.777C133.547 108.465 131.44 109.219 130.827 109.504C130.002 109.891 127.43 111.538 128.973 116.492C130.388 120.77 132.932 123.129 135.601 122.649C136.948 122.412 138.47 121.36 138.384 119.189C138.326 117.665 138.87 116.182 139.896 115.065C140.922 113.949 142.346 113.291 143.856 113.235C145.364 113.185 146.834 113.74 147.942 114.779C149.051 115.818 149.709 117.256 149.771 118.779L149.775 118.778ZM140.705 113.811C139.827 114.394 139.113 115.196 138.632 116.139C138.151 117.083 137.92 118.137 137.96 119.2C138.036 121.098 136.695 122.032 135.526 122.225C133.074 122.666 130.716 120.415 129.372 116.357C127.933 111.736 130.259 110.235 131.006 109.884C131.229 109.781 131.463 109.702 131.704 109.65C132.508 109.476 133.725 109.535 134.647 110.999C135.284 112.005 136.193 112.806 137.267 113.305C138.341 113.804 139.533 113.98 140.701 113.812L140.705 113.811Z"
      fill="#29292F"
    />
    <path
      d="M79.3537 99.8319C78.3518 97.9637 78.0449 95.7977 78.4886 93.7268C78.9323 91.6559 80.0973 89.8173 81.7723 88.5444L83.5295 87.1971L83.785 87.5352L82.0268 88.8827C80.4323 90.0953 79.3233 91.8462 78.9008 93.8182C78.4784 95.7902 78.7704 97.8527 79.7241 99.6319L79.3537 99.8319Z"
      fill="#29292F"
    />
    <rect
      x={72.648}
      y={291.476}
      width={137.734}
      height={9.31028}
      rx={3.39416}
      fill="#ABE3FF"
      stroke="black"
      strokeWidth={0.969761}
    />
    <path
      d="M72.648 295.885H207.931C209.284 295.885 210.382 296.982 210.382 298.336C210.382 299.689 209.284 300.787 207.931 300.787H76.0421C74.1676 300.787 72.648 299.267 72.648 297.392V295.885Z"
      fill="#29A9FF"
      stroke="black"
      strokeWidth={0.969761}
    />
    <path
      d="M181.74 151.929C182.555 148.413 185.688 145.924 189.297 145.924H397.759C402.752 145.924 406.445 150.571 405.317 155.435L372.877 295.266C372.062 298.782 368.929 301.271 365.32 301.271H156.858C151.865 301.271 148.172 296.623 149.301 291.76L181.74 151.929Z"
      fill="#29292F"
    />
    <g clipPath="url(#clip0_461_21205)">
      <g clipPath="url(#clip1_461_21205)">
        <path
          d="M194.315 146.274H402.777C407.545 146.274 411.071 150.712 409.994 155.356L377.554 295.188C376.776 298.545 373.784 300.921 370.338 300.921H161.876C157.108 300.921 153.582 296.483 154.66 291.839L187.099 152.008C187.878 148.651 190.869 146.274 194.315 146.274Z"
          fill="#ABE3FF"
          stroke="black"
          strokeWidth={0.7}
        />
        <mask
          id="path-14-outside-1_461_21205"
          maskUnits="userSpaceOnUse"
          x={243.806}
          y={235.24}
          width={42.1506}
          height={48.007}
          fill="black"
        >
          <rect
            fill="white"
            x={243.806}
            y={235.24}
            width={42.1506}
            height={48.007}
          />
          <path d="M249.713 249.114C253.486 246.935 257.97 246.345 262.179 247.472C266.388 248.6 269.976 251.354 272.155 255.127C274.333 258.9 274.924 263.385 273.796 267.593C272.668 271.802 269.915 275.39 266.141 277.569L263.785 273.488C266.476 271.934 268.44 269.375 269.244 266.374C270.049 263.372 269.628 260.174 268.074 257.483C266.52 254.792 263.961 252.828 260.96 252.024C257.958 251.22 254.76 251.641 252.069 253.195L249.713 249.114Z" />
        </mask>
        <path
          d="M249.713 249.114C253.486 246.935 257.97 246.345 262.179 247.472C266.388 248.6 269.976 251.354 272.155 255.127C274.333 258.9 274.924 263.385 273.796 267.593C272.668 271.802 269.915 275.39 266.141 277.569L263.785 273.488C266.476 271.934 268.44 269.375 269.244 266.374C270.049 263.372 269.628 260.174 268.074 257.483C266.52 254.792 263.961 252.828 260.96 252.024C257.958 251.22 254.76 251.641 252.069 253.195L249.713 249.114Z"
          fill="#C8FBE7"
        />
        <path
          d="M249.713 249.114C253.486 246.935 257.97 246.345 262.179 247.472C266.388 248.6 269.976 251.354 272.155 255.127C274.333 258.9 274.924 263.385 273.796 267.593C272.668 271.802 269.915 275.39 266.141 277.569L263.785 273.488C266.476 271.934 268.44 269.375 269.244 266.374C270.049 263.372 269.628 260.174 268.074 257.483C266.52 254.792 263.961 252.828 260.96 252.024C257.958 251.22 254.76 251.641 252.069 253.195L249.713 249.114Z"
          stroke="#FCFBF7"
          strokeWidth={7.4}
          strokeLinejoin="round"
          mask="url(#path-14-outside-1_461_21205)"
        />
        <mask
          id="path-15-outside-2_461_21205"
          maskUnits="userSpaceOnUse"
          x={247.904}
          y={239.339}
          width={33.9545}
          height={39.8109}
          fill="black"
        >
          <rect
            fill="white"
            x={247.904}
            y={239.339}
            width={33.9545}
            height={39.8109}
          />
          <path d="M249.713 249.114C253.486 246.935 257.97 246.345 262.179 247.473C266.388 248.6 269.976 251.354 272.155 255.127C274.333 258.9 274.924 263.385 273.796 267.593C272.668 271.802 269.915 275.391 266.141 277.569L263.785 273.488C266.476 271.934 268.44 269.375 269.244 266.374C270.049 263.372 269.628 260.174 268.074 257.483C266.52 254.792 263.961 252.828 260.96 252.024C257.958 251.22 254.76 251.641 252.069 253.195L249.713 249.114Z" />
        </mask>
        <path
          d="M249.713 249.114C253.486 246.935 257.97 246.345 262.179 247.473C266.388 248.6 269.976 251.354 272.155 255.127C274.333 258.9 274.924 263.385 273.796 267.593C272.668 271.802 269.915 275.391 266.141 277.569L263.785 273.488C266.476 271.934 268.44 269.375 269.244 266.374C270.049 263.372 269.628 260.174 268.074 257.483C266.52 254.792 263.961 252.828 260.96 252.024C257.958 251.22 254.76 251.641 252.069 253.195L249.713 249.114Z"
          fill="#C8FBE7"
        />
        <path
          d="M249.713 249.114C253.486 246.935 257.97 246.345 262.179 247.473C266.388 248.6 269.976 251.354 272.155 255.127C274.333 258.9 274.924 263.385 273.796 267.593C272.668 271.802 269.915 275.391 266.141 277.569L263.785 273.488C266.476 271.934 268.44 269.375 269.244 266.374C270.049 263.372 269.628 260.174 268.074 257.483C266.52 254.792 263.961 252.828 260.96 252.024C257.958 251.22 254.76 251.641 252.069 253.195L249.713 249.114Z"
          stroke="#29292F"
          strokeWidth={1.4}
          mask="url(#path-15-outside-2_461_21205)"
        />
        <rect
          x={349.53}
          y={165.746}
          width={25.3418}
          height={24.5739}
          rx={5}
          transform="rotate(42.2152 349.53 165.746)"
          fill="white"
        />
        <rect
          x={350.082}
          y={170.655}
          width={18.3044}
          height={17.7968}
          rx={2.65}
          transform="rotate(42.2152 350.082 170.655)"
          fill="#FFE6ED"
          stroke="black"
          strokeWidth={0.7}
        />
        <rect
          x={216.664}
          y={204.177}
          width={17.2391}
          height={16.7167}
          rx={5}
          transform="rotate(42.2152 216.664 204.177)"
          fill="white"
        />
        <rect
          x={217.047}
          y={207.674}
          width={12.228}
          height={11.8827}
          rx={2.65}
          transform="rotate(42.2152 217.047 207.674)"
          fill="#FFE6ED"
          stroke="black"
          strokeWidth={0.7}
        />
        <circle
          cx={204.741}
          cy={265.59}
          r={18.959}
          transform="rotate(-45 204.741 265.59)"
          fill="#FFE9A4"
          stroke="#FCFBF7"
          strokeWidth={3}
        />
        <circle
          cx={204.741}
          cy={265.59}
          r={17.109}
          transform="rotate(-45 204.741 265.59)"
          fill="#FFE9A4"
          stroke="black"
          strokeWidth={0.7}
        />
        <circle
          cx={198.555}
          cy={268.846}
          r={1.93675}
          transform="rotate(-45 198.555 268.846)"
          fill="black"
          stroke="black"
          strokeWidth={0.270818}
        />
        <circle
          cx={207.996}
          cy={259.405}
          r={1.93675}
          transform="rotate(-45 207.996 259.405)"
          fill="black"
          stroke="black"
          strokeWidth={0.270818}
        />
        <circle
          cx={200.806}
          cy={273.657}
          r={1.58058}
          transform="rotate(-45 200.806 273.657)"
          fill="#FFB743"
        />
        <circle
          cx={212.807}
          cy={261.656}
          r={1.58058}
          transform="rotate(-45 212.807 261.656)"
          fill="#FFB743"
        />
        <path
          d="M207.42 264.808C207.617 265.004 207.767 265.244 207.862 265.513C207.957 265.782 207.994 266.075 207.973 266.375C207.951 266.675 207.871 266.976 207.736 267.261C207.602 267.547 207.415 267.811 207.188 268.038C206.961 268.265 206.697 268.452 206.411 268.586C206.126 268.721 205.825 268.801 205.525 268.823C205.225 268.845 204.932 268.807 204.663 268.712C204.394 268.617 204.154 268.467 203.958 268.27"
          stroke="black"
          strokeWidth={0.7}
          strokeLinecap="round"
        />
      </g>
      <path
        d="M316.884 265.961L322.418 275.017C322.817 275.67 323.772 275.651 324.144 274.983L328.12 267.858C328.148 267.807 328.171 267.754 328.19 267.7L339.078 236.475L316.884 265.961Z"
        fill="#FCFBF7"
      />
      <path
        d="M339.078 236.475L305.512 262.418C304.82 262.954 305.1 264.057 305.964 264.197L316.884 265.961L339.078 236.475Z"
        fill="#FCFBF7"
      />
      <path
        d="M339.078 236.475L336.76 268.07C336.717 268.655 336.182 269.078 335.603 268.984L323.483 267.027L339.078 236.475Z"
        fill="#FCFBF7"
      />
      <path
        d="M326.752 267.555C327.437 267.666 327.804 268.423 327.466 269.029L325.257 272.99C324.75 273.899 323.365 273.525 323.384 272.484L323.483 267.027L326.752 267.555Z"
        fill="#FCFBF7"
      />
      <path
        d="M316.884 265.961L322.418 275.017C322.817 275.67 323.772 275.651 324.144 274.983L328.12 267.858C328.148 267.807 328.171 267.754 328.19 267.7L339.078 236.475M316.884 265.961L339.078 236.475M316.884 265.961L305.964 264.197C305.1 264.057 304.82 262.954 305.512 262.418L339.078 236.475M339.078 236.475L336.76 268.07C336.717 268.655 336.182 269.078 335.603 268.984L323.483 267.027M339.078 236.475L323.483 267.027M323.483 267.027L323.384 272.484C323.365 273.525 324.75 273.899 325.257 272.99L327.466 269.029C327.804 268.423 327.437 267.666 326.752 267.555L323.483 267.027Z"
        stroke="#FCFBF7"
        strokeWidth={7}
        strokeLinejoin="round"
      />
      <path
        d="M316.884 265.961L323.31 276.478L328.162 267.782L339.078 236.475L316.884 265.961Z"
        fill="#75F5C4"
        stroke="#29292F"
        strokeWidth={0.7}
        strokeLinejoin="bevel"
      />
      <path
        d="M339.078 236.475L303.687 263.829L316.885 265.96L339.078 236.475Z"
        fill="#C8FBE7"
        stroke="#29292F"
        strokeWidth={0.7}
        strokeLinejoin="round"
      />
      <path
        d="M339.078 236.475L336.68 269.158L323.483 267.027L339.078 236.475Z"
        fill="#FCFBF7"
        stroke="#29292F"
        strokeWidth={0.7}
        strokeLinejoin="round"
      />
      <path
        d="M328.161 267.783L323.312 276.478L323.483 267.027L328.161 267.783Z"
        fill="#38D695"
        stroke="#29292F"
        strokeWidth={0.7}
        strokeLinejoin="bevel"
      />
      <path
        d="M279.814 182.422L270.208 176.623C268.441 175.557 266.162 176.668 265.915 178.717L264.571 189.856L256.088 197.2C254.528 198.551 254.881 201.062 256.753 201.93L266.931 206.651L271.294 216.988C272.097 218.889 274.594 219.329 275.998 217.817L283.633 209.595L294.812 208.64C296.869 208.465 298.059 206.226 297.055 204.423L291.595 194.621L294.141 183.694C294.609 181.684 292.848 179.86 290.823 180.258L279.814 182.422Z"
        fill="#FFD074"
        stroke="#FCFBF7"
        strokeWidth={4}
      />
      <path
        d="M279.343 184.065L269.355 178.036C268.614 177.588 267.657 178.055 267.553 178.915L266.155 190.498C266.141 190.619 266.081 190.731 265.988 190.812L257.168 198.448C256.513 199.015 256.661 200.069 257.447 200.433L268.031 205.342C268.142 205.393 268.23 205.485 268.278 205.598L272.814 216.346C273.151 217.144 274.2 217.329 274.789 216.694L282.728 208.145C282.811 208.056 282.926 208 283.048 207.989L294.672 206.996C295.535 206.923 296.035 205.983 295.613 205.226L289.936 195.034C289.876 194.927 289.859 194.801 289.887 194.682L292.534 183.319C292.731 182.476 291.991 181.71 291.141 181.877L279.694 184.127C279.573 184.151 279.448 184.129 279.343 184.065Z"
        stroke="#29292F"
        strokeWidth={0.7}
      />
      <path
        d="M271.583 184.08L278.326 188.151C278.58 188.304 278.882 188.357 279.174 188.3L286.903 186.781C287.254 186.712 287.56 187.029 287.479 187.378L285.691 195.049C285.624 195.338 285.667 195.642 285.811 195.901L289.644 202.782C289.818 203.095 289.612 203.484 289.255 203.514L281.406 204.185C281.111 204.21 280.835 204.345 280.633 204.562L275.273 210.334C275.029 210.596 274.596 210.52 274.456 210.19L271.393 202.933C271.278 202.66 271.065 202.439 270.796 202.314L263.65 199C263.325 198.849 263.264 198.413 263.535 198.179L269.49 193.023C269.714 192.829 269.858 192.558 269.894 192.264L270.838 184.444C270.88 184.088 271.276 183.895 271.583 184.08Z"
        fill="#FFE9A4"
        stroke="black"
        strokeWidth={0.7}
      />
    </g>
    <path
      d="M185.591 98.3969L185.225 98.2474C183.777 97.6576 182.155 97.6661 180.714 98.2711C179.273 98.8761 178.132 100.028 177.541 101.474L177.42 101.773L176.672 101.536L176.815 101.185C177.412 99.7446 177.415 98.1268 176.826 96.6826C176.536 95.9707 176.106 95.3242 175.562 94.7815C175.017 94.2389 174.369 93.8111 173.657 93.5236L173.375 93.4088L173.571 92.6257L173.945 92.7782C175.342 93.3925 176.914 93.4787 178.369 93.0206C179.103 92.7508 179.77 92.3239 180.323 91.7696C180.875 91.2153 181.299 90.547 181.566 89.8114L182.226 90.0432C181.333 93.0648 182.806 96.4208 185.51 97.5245L185.796 97.6416L185.591 98.3969ZM177.949 99.4586C178.633 98.6484 179.501 98.0144 180.482 97.6102C181.462 97.2059 182.526 97.0431 183.583 97.1355C182.836 96.4529 182.243 95.6189 181.843 94.6891C181.444 93.7593 181.248 92.7552 181.268 91.7439C180.588 92.638 179.66 93.3118 178.599 93.6815C177.669 93.9951 176.678 94.0908 175.704 93.9612C176.481 94.6279 177.088 95.4702 177.474 96.418C177.87 97.3829 178.03 98.428 177.942 99.4668L177.949 99.4586Z"
      fill="#29292F"
    />
    <path
      d="M216.437 123.392L215.643 123.845L215.46 123.583C214.813 122.625 213.982 121.806 213.015 121.174C212.048 120.541 210.965 120.108 209.828 119.9C208.692 119.691 207.526 119.712 206.399 119.96C205.271 120.208 204.205 120.679 203.262 121.345L202.997 121.529L202.474 120.894L202.785 120.677C203.737 120.032 204.55 119.204 205.177 118.24C205.804 117.276 206.232 116.197 206.436 115.065C206.64 113.933 206.616 112.772 206.365 111.649C206.114 110.526 205.641 109.464 204.975 108.526L204.756 108.212L205.448 107.817L205.631 108.08C208.562 112.287 213.354 113.15 217.556 110.227L217.818 110.044L218.442 110.786L218.178 111.012C214.594 114.075 213.717 119.488 216.218 123.078L216.437 123.392ZM204.971 119.656C206.606 119.038 208.382 118.892 210.096 119.236C211.81 119.58 213.394 120.399 214.665 121.6C213.471 118.377 214.197 114.46 216.555 111.657L216.583 111.624C213.142 113.366 209.495 112.887 206.72 110.382C207.288 111.943 207.425 113.628 207.117 115.26C206.81 116.892 206.068 118.41 204.971 119.656V119.656Z"
      fill="#29292F"
    />
    <path
      d="M209.597 56.4342L205.844 53.3369L202.746 57.0893L206.499 60.1866L209.597 56.4342Z"
      fill="#29292F"
    />
    <path
      d="M206.269 60.4637L202.515 57.3665L202.467 56.8612L205.565 53.1087L206.07 53.0603L209.823 56.1577L209.872 56.663L206.774 60.4153L206.269 60.4637ZM203.249 57.0413L206.449 59.6817L209.09 56.4829L205.89 53.8423L203.249 57.0413Z"
      fill="#29292F"
    />
    <path
      d="M212.784 55.9114L218.166 60.3522L211.973 67.8528L206.592 63.412C206.029 62.9478 205.674 62.2793 205.605 61.5534C205.535 60.8274 205.757 60.1037 206.222 59.5413L208.913 56.2816C209.377 55.7192 210.046 55.3643 210.772 55.2949C211.498 55.2255 212.222 55.4472 212.784 55.9114V55.9114Z"
      fill="#29A9FF"
    />
    <path
      d="M211.744 68.1304L206.363 63.6894C205.727 63.1641 205.327 62.4083 205.248 61.588C205.17 60.7676 205.42 59.9497 205.944 59.3136L208.635 56.0538C209.16 55.4188 209.916 55.0181 210.737 54.9397C211.558 54.8613 212.376 55.1115 213.012 55.6356L218.393 60.0762L218.442 60.5815L212.249 68.0821L211.744 68.1304ZM206.82 63.1359L211.924 67.3484L217.66 60.4014L212.555 56.1891C212.066 55.786 211.436 55.5934 210.805 55.6537C210.174 55.7141 209.592 56.0223 209.188 56.5108L206.498 59.7706C206.094 60.2595 205.901 60.8888 205.961 61.5199C206.022 62.151 206.331 62.7323 206.82 63.1359V63.1359Z"
      fill="#29292F"
    />
    <path
      d="M281.206 117.315L279.567 119.301L283.467 120.85L281.206 117.315Z"
      fill="black"
    />
    <path
      d="M274.389 106.863L281.148 117.433L279.687 119.053L268.118 114.458L274.389 106.863Z"
      fill="#29A9FF"
    />
    <path
      d="M279.554 119.387L267.986 114.792L267.842 114.23L274.112 106.635L274.691 106.67L281.45 117.239L281.415 117.673L279.954 119.294L279.554 119.387ZM268.709 114.307L279.587 118.628L280.698 117.395L274.352 107.472L268.709 114.307Z"
      fill="#29292F"
    />
    <path
      d="M274.53 106.868L215.991 58.561L209.721 66.1561L268.259 114.463L274.53 106.868Z"
      fill="#F4F3ED"
    />
    <path
      d="M268.302 114.889L268.07 114.697L209.298 66.1973L215.953 58.1367L216.186 58.329L274.957 106.829L268.302 114.889ZM210.148 66.116L268.221 114.039L274.107 106.91L216.034 58.9867L210.148 66.116Z"
      fill="#29292F"
    />
    <path
      d="M213.282 61.8428L212.824 62.3965L229.402 76.0766L229.859 75.5229L213.282 61.8428Z"
      fill="#29292F"
    />
    <path
      d="M254.676 29.0084H253.958V81.6228H254.676V29.0084Z"
      fill="#29292F"
    />
    <path
      d="M262.625 66.8899H261.907V88.4269H262.625V66.8899Z"
      fill="#29292F"
    />
    <path
      d="M394.506 78.1826L393.87 77.8496L369.467 124.462L370.103 124.795L394.506 78.1826Z"
      fill="#29292F"
    />
    <path
      d="M390.146 105.454L389.51 105.121L375.169 132.515L375.805 132.848L390.146 105.454Z"
      fill="#29292F"
    />
    <path
      d="M347.841 120.311L324.856 104.467L333.734 94.7637L355.741 109.933C355.741 109.933 348.901 117.384 348.023 118.369C347.775 118.622 347.622 118.954 347.588 119.307C347.555 119.661 347.644 120.015 347.841 120.311Z"
      fill="#FF960B"
    />
    <path
      d="M347.669 120.561L324.684 104.717L324.633 104.263L333.511 94.5591L333.905 94.5143L355.912 109.684L355.963 110.138C355.895 110.213 349.115 117.599 348.249 118.57C348.043 118.771 347.915 119.037 347.885 119.323C347.856 119.609 347.927 119.896 348.086 120.134L347.669 120.561ZM325.314 104.416L347.281 119.557C347.269 119.303 347.308 119.048 347.397 118.809C347.486 118.57 347.622 118.352 347.797 118.167C348.574 117.296 354.07 111.306 355.282 109.985L333.779 95.1629L325.314 104.416Z"
      fill="#29292F"
    />
    <path
      d="M342.977 115.247L342.487 114.891L352.207 101.443C352.48 101.046 352.886 100.761 353.351 100.638C353.816 100.516 354.309 100.565 354.741 100.778C355.207 101.004 356.781 101.688 357.493 100.969C357.614 100.86 357.71 100.726 357.774 100.576C357.837 100.426 357.867 100.264 357.862 100.101C357.824 99.3575 357.074 98.3947 355.569 97.1574C353.163 95.1797 351.754 94.7073 350.704 95.5267C350.175 95.9397 350.353 96.5678 350.688 97.5584C351.044 98.6117 350.787 99.4583 349.987 99.893L333.703 108.56L333.42 108.025L349.701 99.3593C350.369 98.9959 350.298 98.2918 350.12 97.7651C349.782 96.767 349.437 95.7474 350.332 95.0486C351.966 93.7729 353.999 95.0831 355.952 96.6891C357.619 98.0594 358.418 99.1338 358.466 100.07C358.476 100.317 358.433 100.564 358.339 100.793C358.246 101.021 358.104 101.227 357.923 101.396C356.988 102.338 355.362 101.754 354.477 101.322C354.173 101.174 353.827 101.14 353.501 101.227C353.175 101.314 352.891 101.515 352.701 101.794L342.977 115.247Z"
      fill="#29292F"
    />
    <path
      d="M355.739 109.933L354.464 103.834L331.684 88.1313L333.733 94.7637L355.739 109.933Z"
      fill="#29292F"
    />
    <path
      d="M355.568 110.183L333.561 95.0134L333.443 94.8534L331.394 88.221L331.854 87.882L354.635 103.585L354.76 103.772L356.035 109.871L355.568 110.183ZM333.99 94.574L355.288 109.255L354.192 104.015L332.23 88.8762L333.99 94.574Z"
      fill="#29292F"
    />
    <path
      d="M354.465 103.833L331.901 88.2798L323.046 101.169L345.611 116.723L354.465 103.833Z"
      fill="#FFB743"
    />
    <path
      d="M345.438 116.973L322.874 101.419L322.796 100.997L331.65 88.1081L332.071 88.0304L354.635 103.584L354.713 104.005L345.859 116.895L345.438 116.973ZM323.466 101.091L345.532 116.302L354.043 103.912L331.977 88.7013L323.466 101.091Z"
      fill="#29292F"
    />
    <path
      d="M340.459 113.583L339.888 113.382L348.061 90.1016C348.264 89.4921 348.673 88.9724 349.217 88.6309C349.76 88.2895 350.405 88.1476 351.042 88.2293C352.517 88.4549 354.002 88.4672 354.882 87.0422C356.374 84.6271 353.49 82.3013 351.638 81.1298C348.432 79.1027 345.831 78.9038 344.68 80.5982C343.714 82.017 344.285 83.282 344.971 84.3324C345.315 84.8617 345.468 85.4925 345.405 86.1206C345.342 86.7487 345.067 87.3365 344.625 87.7868L327.625 105.616L327.188 105.198L344.192 87.3641C344.538 87.0126 344.753 86.5532 344.803 86.0622C344.853 85.5711 344.733 85.0778 344.465 84.664C343.775 83.6069 342.994 81.9999 344.179 80.257C345.538 78.26 348.446 78.3947 351.961 80.6173C355.435 82.8145 356.687 85.2725 355.396 87.361C354.184 89.3244 351.917 88.9767 350.951 88.8281C350.453 88.7679 349.95 88.8821 349.527 89.1513C349.104 89.4204 348.788 89.8279 348.631 90.3046L340.459 113.583Z"
      fill="#29292F"
    />
    <path
      d="M322.795 100.245L322.728 100.324C322.503 100.234 322.257 100.206 322.017 100.242C321.777 100.279 321.551 100.379 321.362 100.532C321.072 100.731 320.872 101.036 320.804 101.382C320.736 101.727 320.807 102.085 321.001 102.379L343.503 117.307L345.742 115.485L322.795 100.245Z"
      fill="#FFB743"
    />
    <path
      d="M343.336 117.56L320.833 102.632L320.766 102.571C320.243 101.925 320.425 100.905 321.171 100.298C321.392 100.117 321.655 99.9966 321.936 99.9479C322.217 99.8992 322.506 99.924 322.774 100.02L322.961 99.9933L345.909 115.233L345.933 115.721L343.693 117.542L343.336 117.56ZM321.209 102.155L343.485 116.932L345.232 115.51L322.747 100.578L322.628 100.61C322.451 100.538 322.258 100.515 322.069 100.543C321.88 100.571 321.701 100.649 321.553 100.768C321.333 100.915 321.176 101.139 321.113 101.395C321.049 101.652 321.084 101.923 321.209 102.155Z"
      fill="#29292F"
    />
    <path
      d="M345.382 117.332C346 116.829 346.162 116.003 345.743 115.486C345.324 114.969 344.483 114.958 343.865 115.461C343.246 115.964 343.085 116.79 343.504 117.307C343.922 117.824 344.763 117.835 345.382 117.332Z"
      fill="#29292F"
    />
    <path
      d="M344.387 118.005L344.364 118.004C344.155 118.009 343.948 117.966 343.758 117.878C343.568 117.79 343.401 117.66 343.269 117.497C343.138 117.335 343.045 117.144 342.998 116.94C342.951 116.736 342.951 116.524 342.999 116.32C343.09 115.887 343.329 115.5 343.675 115.225C344.013 114.94 344.441 114.785 344.883 114.787C345.092 114.783 345.3 114.826 345.49 114.914C345.679 115.002 345.846 115.132 345.978 115.294C346.11 115.457 346.203 115.648 346.25 115.852C346.297 116.056 346.296 116.268 346.249 116.472C346.158 116.905 345.919 117.292 345.573 117.567V117.567C345.239 117.844 344.82 117.999 344.387 118.005V118.005ZM344.861 115.393C344.564 115.404 344.28 115.511 344.051 115.7C343.821 115.888 343.66 116.147 343.592 116.436C343.562 116.553 343.559 116.675 343.585 116.793C343.61 116.911 343.663 117.022 343.739 117.115C343.815 117.209 343.912 117.284 344.022 117.333C344.132 117.382 344.252 117.404 344.372 117.398L344.387 117.399C344.683 117.388 344.968 117.28 345.197 117.092C345.426 116.903 345.587 116.645 345.655 116.355C345.686 116.239 345.688 116.116 345.663 115.998C345.638 115.88 345.585 115.77 345.509 115.676C345.433 115.583 345.336 115.508 345.226 115.459C345.116 115.41 344.996 115.387 344.875 115.393L344.861 115.393Z"
      fill="#29292F"
    />
    <path
      d="M349.379 120.011C349.949 119.547 350.129 118.824 349.78 118.394C349.432 117.965 348.688 117.992 348.119 118.455C347.549 118.918 347.369 119.642 347.718 120.072C348.066 120.501 348.81 120.474 349.379 120.011Z"
      fill="#29292F"
    />
    <path
      d="M348.42 120.678C348.242 120.684 348.066 120.65 347.903 120.578C347.74 120.506 347.596 120.399 347.481 120.264C347.028 119.705 347.227 118.789 347.926 118.221C348.623 117.653 349.56 117.645 350.013 118.204C350.466 118.763 350.266 119.679 349.568 120.247V120.247C349.245 120.517 348.84 120.669 348.42 120.678V120.678ZM349.077 118.393C348.794 118.403 348.523 118.508 348.307 118.691C347.875 119.042 347.712 119.588 347.95 119.882C348.189 120.176 348.756 120.127 349.187 119.776C349.618 119.425 349.782 118.88 349.544 118.586C349.485 118.521 349.413 118.47 349.332 118.436C349.251 118.403 349.164 118.388 349.077 118.393Z"
      fill="#29292F"
    />
    <path
      d="M370.483 238.571H425.673C426.056 238.571 426.356 238.9 426.32 239.282L419.488 311.805C419.463 312.073 419.277 312.291 419.025 312.354C416.72 312.932 408.549 314.774 398.078 314.774C387.608 314.774 379.437 312.932 377.132 312.354C376.879 312.291 376.694 312.073 376.668 311.805L369.836 239.282C369.8 238.9 370.1 238.571 370.483 238.571Z"
      fill="#FCFBF7"
      stroke="#29292F"
      strokeWidth={0.7}
    />
    <mask
      id="path-67-inside-3_461_21205"
      fill="white"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M374.762 295.302L370.857 253.854H425.299L421.394 295.302H374.762Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M374.762 295.302L370.857 253.854H425.299L421.394 295.302H374.762Z"
      fill="#29A9FF"
    />
    <path
      d="M374.762 295.302L374.065 295.367L374.125 296.002H374.762V295.302ZM370.857 253.854V253.154H370.088L370.161 253.92L370.857 253.854ZM425.299 253.854L425.996 253.92L426.068 253.154H425.299V253.854ZM421.394 295.302V296.002H422.032L422.091 295.367L421.394 295.302ZM375.459 295.236L371.554 253.789L370.161 253.92L374.065 295.367L375.459 295.236ZM370.857 254.554H425.299V253.154H370.857V254.554ZM424.602 253.789L420.698 295.236L422.091 295.367L425.996 253.92L424.602 253.789ZM421.394 294.602H374.762V296.002H421.394V294.602Z"
      fill="#29292F"
      mask="url(#path-67-inside-3_461_21205)"
    />
    <path
      d="M372.707 229.173L423.382 224.772C423.762 224.739 424.088 225.039 424.088 225.42V234.31C424.088 234.669 423.797 234.96 423.438 234.96H372.763C372.404 234.96 372.113 234.669 372.113 234.31V229.82C372.113 229.483 372.371 229.202 372.707 229.173Z"
      fill="#E0DDD5"
      stroke="#29292F"
      strokeWidth={0.7}
    />
    <rect
      x={366.232}
      y={232.996}
      width={64.3122}
      height={5.81465}
      rx={0.65}
      fill="#F4F3ED"
      stroke="#29292F"
      strokeWidth={0.7}
    />
    <circle
      cx={398.078}
      cy={274.578}
      r={15.627}
      fill="#FCFBF7"
    />
    <circle
      cx={398.078}
      cy={274.578}
      r={13.6444}
      fill="#FFE9A4"
      stroke="black"
      strokeWidth={0.7}
    />
    <path
      d="M397.135 274.604L397.135 274.606C397.136 275.561 396.794 276.484 396.171 277.207C395.548 277.931 394.685 278.406 393.741 278.546C393.741 278.546 393.741 278.546 393.74 278.546L391.683 278.838C390.679 276.551 391.529 273.204 394.09 270.609C395.643 269.063 397.495 268.13 399.224 267.861C400.766 267.62 402.189 267.908 403.235 268.731L402.094 268.894L402.093 268.894C400.72 269.094 399.464 269.781 398.554 270.829C397.644 271.877 397.141 273.217 397.135 274.604Z"
      fill="#FFB743"
      stroke="black"
      strokeWidth={0.7}
      strokeLinejoin="round"
    />
    <path
      d="M393.998 280.324L394 280.324C395.372 280.12 396.626 279.431 397.534 278.382C398.442 277.334 398.944 275.994 398.949 274.607C398.959 273.66 399.306 272.746 399.93 272.033C400.554 271.319 401.412 270.851 402.35 270.715C402.35 270.715 402.35 270.715 402.351 270.715L404.481 270.409C405.473 272.662 404.599 276.011 402.053 278.551C400.5 280.098 398.647 281.029 396.919 281.296C395.406 281.531 394.009 281.257 392.969 280.471L393.998 280.324Z"
      fill="#FFB743"
      stroke="black"
      strokeWidth={0.7}
      strokeLinejoin="round"
    />
    <defs>
      <clipPath id="clip0_461_21205">
        <rect
          width={260.429}
          height={155.347}
          fill="white"
          transform="translate(152.112 145.924)"
        />
      </clipPath>
      <clipPath id="clip1_461_21205">
        <rect
          width={260.429}
          height={155.347}
          fill="white"
          transform="translate(152.112 145.924)"
        />
      </clipPath>
    </defs>
  </svg>
);
const SvgDesktopAppDownload = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgDesktopAppDownload;
